import { FinancialApplicationFormSectionSummary } from "../FinancialApplicationFormSectionSummary/FinancialApplicationFormSectionSummary";
import { FIELD_KEYS } from "@/constants";
import { useFieldSchemaToGetDataForSummary } from "../FinancialApplicationFormSectionSummary/useFieldSchemaToGetDataForSummary";
import { FieldInput } from "@/utils/getFieldSchemaData";
import { SUBSTEP_PATHS } from "@/config/stepPaths";

export interface OrganizationAccountAcceptableUseSummaryProps {
  financialApplicationId: string;
}

const fieldsToInclude: FieldInput[] = [
  {
    fieldProps: FIELD_KEYS.FINANCIAL_APPLICATION.ORGANIZATION_ACCOUNT_ACCEPTABLE_USE,
  },
];

export const OrganizationAccountAcceptableUseSummary: React.FC<
  OrganizationAccountAcceptableUseSummaryProps
> = ({ financialApplicationId }) => {
  const summaryData = useFieldSchemaToGetDataForSummary(financialApplicationId, fieldsToInclude);

  return (
    <FinancialApplicationFormSectionSummary
      title="Additional Information"
      data={summaryData}
      navigateTo={`/step/${SUBSTEP_PATHS.AdditionalInfo.OrganizationAcceptableUse}`}
    />
  );
};
